import { NO_ROWS_LABEL } from '@/constants/reportingDashboard';
import { Sync } from '@mui/icons-material';
import { Link, Tooltip } from '@mui/material';

interface IProps {
  onRefresh?: () => void;
  /**
   * Set when the BE flagged a snapshot-cache miss + enqueued an on-demand
   * prefetch. Swaps the empty-state copy to tell the user their report is
   * being generated rather than implying "no data exists for this filter".
   */
  refreshing?: boolean;
}

export const NoRowsOverlay = ({ onRefresh, refreshing }: IProps) => {
  if (!onRefresh) {
    return <div className='text-center w-full py-8'>{NO_ROWS_LABEL}</div>;
  }

  if (refreshing) {
    return (
      <div className='text-center w-full py-8 text-[#84818A]'>
        We're generating your report for this date range.
        <br />
        <span className='text-sm'>
          This usually takes 5–10 minutes — we'll check automatically every couple of minutes. You can also click
          Refresh below.
        </span>
        <div className='mt-3'>
          <Link className='cursor-pointer' onClick={onRefresh}>
            Refresh
            <Sync className='align-middle ml-1' fontSize='small' />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className='text-center w-full py-8 text-[#84818A]'>
      No data for the selected filters.
      <div className='mt-3'>
        <Tooltip
          title='Re-runs the same query. If you just picked a custom date range, the snapshot may still be generating — try again in 5–10 minutes.'
          arrow
          placement='top'
        >
          <Link className='cursor-pointer' onClick={onRefresh}>
            Refresh
            <Sync className='align-middle ml-1' fontSize='small' />
          </Link>
        </Tooltip>
      </div>
    </div>
  );
};
